/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NotificationChannel = zod
  .enum(['in_app', 'push', 'email', 'sms'])
  .describe('Delivery channel for a notification topic');

export type NotificationChannel = zod.input<typeof NotificationChannel>;
export type NotificationChannelOutput = zod.output<typeof NotificationChannel>;
